<template>
  <div class="text-center padding-xl">
    <el-steps :active="0" align-center class="padding-tb-xl" process-status="finish">
      <el-step title="选择订户类型"></el-step>
      <el-step title="填写征订单"></el-step>
      <el-step title="订单支付"></el-step>
      <el-step title="发票开具"></el-step>
    </el-steps>
    <div class="flex justify-center align-center padding-xl">
      <button :class="modeIndex === 0 ? 'line-red' : 'line-gray'" :data-index="0" class="cu-btn round margin-lr"
              @click="modeSwitch">
        <i class="cuIcon-people"><span class="padding-left-xs">单地址订阅</span></i>
      </button>
      <button :class="modeIndex === 1 ? 'line-red' : 'line-gray'" :data-index="1" class="cu-btn round margin-lr"
              @click="modeSwitch">
        <i class="cuIcon-group"><span class="padding-left-xs">集体订阅</span></i>
      </button>
    </div>
    <div class="padding-xl"></div>
    <button class="cu-btn bg-red round lg" style="width:200px" @click="nextStep">下一步</button>
    <div class="padding-xl text-left" style="padding: 0">
      <div class="text-bold" style="margin: 0 auto; text-align: left; width: 600px">
        <div class="padding-tb">温馨提示：</div>
        <div style="padding: 5px">1、单地址订阅：填写单一地址及收件人</div>
        <div style="padding: 5px">2、集体订阅：需下载导入模板，导入多个地址和多个收件人</div>
        <div style="padding: 5px">3、征订单导入模板中的征订起始期、征订结束期、份数请填写数字</div>
        <div style="padding: 5px">4、请勿重复提交订单，上传汇款凭证、提前开票的订单，后台管理</div>
        <div style="text-indent: 1.5em">员审核通过后，会根据您填写的开票信息自动开票</div>
      </div>
    </div>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="温馨提示"
               :visible.sync="singleShow"
               width="30%">
      <span>填写单一地址及收件人</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="singleShow = false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog :show-close="false" :close-on-click-modal="false"
               title="温馨提示"
               :visible.sync="multiShow"
               width="30%">
      <span>需下载导入模板，导入多个地址和多个收件人</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="multiShow =  false">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'mode',
  data () {
    return {
      singleShow: false,
      multiShow: false,
      path: ['/pages/subscribe/subscribe', '/pages/subscribe/subscribe-multi'],
      modeIndex: 0
    }
  },
  created () {
    sessionStorage.removeItem('order-multi')
    sessionStorage.removeItem('order')
  },
  methods: {
    modeSwitch (e) {
      this.modeIndex = parseInt(e.currentTarget.dataset.index)
      if (this.modeIndex === 0) {
        this.singleShow = true
      } else if (this.modeIndex === 1) {
        this.multiShow = true
      }
    },
    nextStep () {
      this.$router.push({ path: this.path[this.modeIndex] })
    }
  }
}
</script>

<style scoped>
.margin-lr {
  width: 200px;
  height: 60px;
  padding: 20px;
  font-size: 20px;
  cursor: pointer;
}
</style>
